<template>
  <div class="ro mb-5">
    <div class="">
      <nav class="navbar navbar-expand-lg bg-nav">
        <router-link :to="{ name: 'home' }" class="navbar-brand">Home</router-link>
        <button
          class="navbar-toggler"
          type="button"
          @click="expanded = !expanded"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>

        <!-- mobile nav -->
        <div class="navbar-toggler w-100" v-show="expanded" @click="expanded = false">
          <ul class="navbar-nav w-100 text-left pl-2 mt-2">
            <li class="nav-item mb-4">
              <router-link :to="{ name: 'discover' }" class="">Discover</router-link>
            </li>
            <li class="nav-item mb-4 d-flex">
              <router-link :to="{ name: 'create' }" class="btn btn-warning btn-sm">
                <i class="tim-icons icon-simple-add"></i> New List</router-link
              >
            </li>
            <li class="nav-item mb-4" v-if="isAuth">
              <router-link :to="{ name: 'profile', params: { username: user.username } }" href="#">
                <span class="mr-2">{{ user.username }}</span>
                <i class="tim-icons icon-single-02" aria-hidden="true"></i>
              </router-link>
            </li>
            <template v-if="isAuth">
              <li class="nav-item mb-4">
                <router-link :to="{ name: 'settings' }">Settings</router-link>
              </li>
              <li class="nav-item mb-4">
                <a href="#" @click.prevent="logOut">Log Out</a>
              </li>
            </template>
            <template v-else>
              <li class="nav-item mb-4">
                <router-link :to="{ name: 'login' }">Log In</router-link>
              </li>
              <li class="nav-item mb-4">
                <router-link :to="{ name: 'register' }">Register</router-link>
              </li>
            </template>
          </ul>
        </div>
        <!-- end mobile nav -->

        <!-- desktop nav -->
        <div class="collapse navbar-collapse" id="">
          <ul class="navbar-nav w-100">
            <li class="nav-item">
              <router-link :to="{ name: 'discover' }" class="navbar-brand">Discover</router-link>
            </li>
            <li class="nav-item mr-auto d-flex align-items-center">
              <router-link :to="{ name: 'create' }" class="btn btn-warning btn-sm"
                ><i class="tim-icons icon-simple-add"></i> New List</router-link
              >
            </li>
            <li class="nav-item" v-if="isAuth">
              <router-link
                :to="{ name: 'profile', params: { username: user.username } }"
                class="nav-link"
                href="#"
              >
                <span class="mx-2">{{ user.username }}</span>
                <i class="tim-icons icon-single-02" aria-hidden="true"></i>
              </router-link>
            </li>
            <li class="nav-item">
              <base-dropdown position="right" class="dropdown-icon-button">
                <a slot="title" type="secondary" class="dropdown-toggle">
                  <i class="tim-icons icon-settings-gear-63"></i>
                </a>
                <template v-if="isAuth">
                  <router-link class="dropdown-item" :to="{ name: 'settings' }"
                    >Settings</router-link
                  >
                  <a class="dropdown-item" href="#" @click.prevent="logOut">Log Out</a>
                </template>
                <template v-else>
                  <router-link class="dropdown-item" :to="{ name: 'login' }">Log In</router-link>
                  <router-link class="dropdown-item" :to="{ name: 'register' }"
                    >Register</router-link
                  >
                </template>
              </base-dropdown>
            </li>
          </ul>
        </div>
        <!-- end desktop nav -->
      </nav>
    </div>
  </div>
</template>

<script>
import BaseDropdown from "@/components/BaseDropdown"
import { mapState, mapGetters } from "vuex"

export default {
  name: "NavBar",
  components: {
    BaseDropdown,
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
    }),
    ...mapGetters({
      isAuth: "users/isAuth",
    }),
  },
  methods: {
    logOut() {
      this.$store.dispatch("users/logOutUser")
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar.bg-nav {
  border: 1px solid #1d8cf8 !important;
  background: #1f1f21 !important;
}
.navbar {
  border-radius: 0.2857rem;
  .nav-item {
    .dropdown-icon-button {
      padding: 0.2rem 0;
    }
  }
}
.navbar .navbar-brand,
.navbar .nav-link {
  padding: 0.3125rem 0.625rem;
  border-radius: 5px;
  &:hover {
    background: #3099ff;
  }
}
</style>
